import { Affix, Button, Card, Form } from "antd";
import { isMobileView } from "components/Common/AppHelper";
import Header from "components/Common/Header";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import IOUDocumentsForm from "../IOUDocumentsForm";
import { useEffect } from "react";

const AddIOUDocuments = (props) => {
  const { width } = props;
  const [form] = Form.useForm();
  const navigate = useNavigate();

  // Get current user info from Redux store
  const currentUser = useSelector((state) => state.auth?.user);

  useEffect(() => {
    navigate("/import-export-expense-tracking/iou-disbursement");
  }, [navigate]);

  const discardForm = () => {
    navigate("/import-export-expense-tracking/iou-disbursement");
  };

  const addNewIOUCost = () => {
    form.submit();
  };

  return (
    <>
      <Affix offsetTop={0}>
        <Card className="p-fixed" style={{ width: `${isMobileView() ? "100%" : `${width}px`}` }}>
          <Header
            title="Add New IOU Request"
            subTitle=""
            addLink="/"
            addText="Add New"
            actions={[
              <Button size="small" key={1} danger onClick={() => discardForm()}>
                Discard
              </Button>,
              <Button size="small" key={2} type="primary" onClick={() => addNewIOUCost()}>
                Submit Request
              </Button>,
            ]}
          />
        </Card>
      </Affix>

      <IOUDocumentsForm form={form} currentUser={currentUser} createMode={true} />
    </>
  );
};

export default AddIOUDocuments;
